<div>
  @if (fromDataView; as info) {
    @for (info of templateRecordInfo; track trackByModel($index, info)) {
      <lm-template-form-record
        [class.lm-question-hidden]="!info.isQuestionVisible"
        [info]="info"
        [formUrlInfo]="formUrlInfo"
        [formSpec]="formSpec"
        [formOptions]="formOptions"
        [specFields]="specFields"
        [layout]="layout"
        [model]="info.model"
        (templateFieldEvent)="onFieldEvent($event, info)"
        >
      </lm-template-form-record>
    }
  }
  @if (showEmptyMessage) {
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  }
</div>

<div #dialogPlaceholder id="lmFormContentTemplateDialogPlaceholder" class="lmDialogPlaceholder"></div>
